// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import { LazyImageStyle } from "@insite/mobius/LazyImage";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { infoCardStyles } from "@synd/App/Widgets/Basic/InfoCard";
import PaginationRightArrow from "@synd/XDL/Icons/PaginationRightArrow";
import { fontConfig } from "@synd/XDL/PreStyle/typography";
import { color, ellipsis, xScreen } from "@synd/XDL/Utilities";
import { css } from "styled-components";

infoCardStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        padding: 12px;
        row-gap: 16px;
        ${({ addBorder }: any) =>
            addBorder &&
            css`
                border: 1px solid ${color("common.border")};
            `};
        background-color: ${({ backgroundColor }: any) => backgroundColor || "transparent"};
        border-radius: 8px;
        overflow: hidden;
        height: 100%;
    `,
};

infoCardStyles.imageWrapperStyles = {
    css: css`
        ${LazyImageStyle} {
            display: flex;
            border-radius: 8px;
            aspect-ratio: 293 / 320;
            ${xScreen("lte", "md")} {
                aspect-ratio: 293 / 364;
            }
            ${xScreen("lte", "sm")} {
                aspect-ratio: 304 / 332;
            }

            ${({ isHorizontalImage }: any) =>
                isHorizontalImage &&
                css`
                    aspect-ratio: 285 / 98;
                    ${xScreen("lte", "md")} {
                        aspect-ratio: 326 / 98;
                    }
                    ${xScreen("lte", "sm")} {
                        aspect-ratio: 296 / 98;
                    }
                `};

            picture {
                width: 100%;
                height: 100%;
                img {
                    object-fit: cover;
                    width: 100%;
                    height: 100%;
                }
            }
        }
    `,
};

infoCardStyles.content = {
    css: css`
        display: flex;
        flex-direction: column;
        justify-content: start;
        height: 100%;
    `,
};
infoCardStyles.textWrapperStyles = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 8px;
        margin-bottom: 12px;
    `,
};

infoCardStyles.heading = {
    css: css`
        &,
        ${TypographyStyle} {
            line-height: ${fontConfig.smallHeadLine.lineHeight};
            font-size: ${fontConfig.smallHeadLine.size}px;
            margin: 0;
            height: 52px;
            ${ellipsis(2)}
        }
    `,
};

infoCardStyles.subHeading = {
    css: css`
        &,
        ${TypographyStyle} {
            line-height: ${fontConfig.small.lineHeight};
            font-size: ${fontConfig.small.size}px;
            margin: 0;

            ${({ numberOfSubheadingLines }: any) =>
                numberOfSubheadingLines &&
                css`
                    ${ellipsis(numberOfSubheadingLines)}
                `};
        }
    `,
};

infoCardStyles.infoCardButtonWrapper = {
    css: css`
        margin-top: auto;
    `,
};

infoCardStyles.infoCardButton = {
    icon: {
        position: "right",
        src: PaginationRightArrow,
    },
    css: css`
        ${IconWrapper} {
            &,
            svg {
                width: 5px;
                height: 11px;
            }
        }
    `,
};
